import Modal from "src/components/Modal";
import {
  Alert,
  FormLabel,
  FormControl,
  Switch,
  Button,
  Text,
  VStack,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import React from "react";

import axios, { getAxiosParams } from "src/lib/axios.config";
import { SubscriptionsApi } from "typescript-axios";
import { toastPromise } from "src/JSONForm";
import { usePageContext } from "vike-react/usePageContext";
import { deleteSearchParam } from "src/lib/utils";
const SUBS_API = new SubscriptionsApi(getAxiosParams(), undefined, axios);

const SubscribeModal = ({ onSuccess, ...rest }) => {
  const toast = useToast();
  const [isYearly, setIsYearly] = React.useState<boolean>(true);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { urlParsed: { search } } = usePageContext();

  // for limited offer we only propose PRO at the price of INDIVIDUAL
  const planId = isYearly
    ? import.meta.env.VITE_STRIPE_PRO_YEARLY_EUR
    : import.meta.env.VITE_STRIPE_PRO_MONTHLY_EUR;

  const price = isYearly
    ? import.meta.env.VITE_STRIPE_PRO_YEARLY_EUR_PRICE
    : import.meta.env.VITE_STRIPE_PRO_MONTHLY_EUR_PRICE;


  const getUrlAndRedirect = () => {
    if (typeof window === "undefined") return;
    const successUrl = window.location.href;
    setIsLoading(true);
    toastPromise(
      SUBS_API.checkoutApiV1SubscriptionsCheckoutGet(
        planId,
        successUrl,
        successUrl
      )
        .then((res) => {
          window.location.href = res.data;
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
          throw err;
        }),
      toast
    );
  };

  React.useEffect(() => {
    const { subRef } = search;
    if (subRef) {
      toast({
        title: "One moment...",
        status: "info",
        duration: 10000,
      });
      SUBS_API.checkSubscriptionApiV1SubscriptionsCheckRefGet(subRef)
        .then((res) => {
          toast.closeAll();
          if (res.data.current_plan) {
            toast({
              title: "Subscription successful!",
              status: "success",
            });
            onSuccess(res.data.current_plan);
          } else {
            toast({
              title: "Could not check subscription",
              status: "warning",
            });
          }
        })
        .catch((err) => {
          toast({
            title: "An error occurred",
            status: "error",
          });
          console.error(err);
        })
        .finally(() => {
          deleteSearchParam("subRef");
        });
    }
  }, []);

  return (
    <Modal header="Subscribe" {...rest}>
      <VStack>
        <Text>
          You've reached the limit of flows for your plan. Subscribe to unlock
          more!
        </Text>
        <Alert variant="left-accent" status="info" w="100%">
          <Text>
            <FormControl display="flex" alignItems="center">
              <FormLabel
                htmlFor="is-yearly-subscription"
                mb="0"
                fontWeight="bold"
              >
                🔥 Save 70% with yearly subscription
              </FormLabel>
              <Switch
                id="is-yearly-subscription"
                isChecked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
                colorScheme="brand"
                size="lg"
              />
            </FormControl>{" "}
          </Text>
        </Alert>
        {search.subRef ? (
          <Spinner />
        ) : (
          <Button
            isDisabled={Boolean(isLoading || search.subRef)}
            colorScheme="brand"
            size="lg"
            mt={4}
            w="100%"
            onClick={getUrlAndRedirect}
          >
            Subscribe for {price}
            €/month
          </Button>
        )}
      </VStack>
    </Modal>
  );
};
export default SubscribeModal;
